export const LOAN_TYPE_HELOC_SUBSTRING = "HELOC";
export const SECOND_MORT_LIEN_POS = 2;
